import { UpdateStaticContentTemplateComponent } from './update-static-content-template/update-static-content-template.component'
import { StaticContentTemplatesComponent } from './static-content-templates.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const staticContentTemplatesRoutes: Routes = [
  {
    path: 'admin/static-content-templates',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'STATIC_CONTENT_TEMPLATES',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', component: StaticContentTemplatesComponent },
      { path: ':id/update', component: UpdateStaticContentTemplateComponent },
    ],
  },
]
